import { Link } from "react-router-dom";

const perks = [
  { icon: "ri-book-read-line", label: "全库畅读" },
  { icon: "ri-flashlight-line", label: "抢先看新" },
  { icon: "ri-settings-3-line", label: "豪华画质" },
  { icon: "ri-bubble-chart-line", label: "纯净阅读" },
  { icon: "ri-vip-crown-line", label: "专属标识" },
];

function VipBanner() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-8 md:py-10">
      <div className="relative overflow-hidden rounded-2xl border border-primary-500/30 bg-gradient-to-br from-background-900 via-background-950 to-primary-900/30 p-8 md:p-14">
        <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-primary-500/15 blur-3xl"></div>
        <div className="absolute -bottom-24 left-1/3 h-64 w-64 rounded-full bg-accent-500/10 blur-3xl"></div>

        <div className="relative flex flex-col items-center gap-8 text-center lg:flex-row lg:text-left">
          <div className="flex-1">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/40 bg-primary-500/10 px-4 py-1.5 text-xs font-semibold text-primary-300">
              <i className="ri-vip-diamond-fill"></i>
              VIP 专属特权
            </span>
            <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-50 md:text-4xl">
              解锁贵族专属特权
              <br />
              <span className="text-gold-grad">畅享钻石级阅读体验</span>
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-7 text-foreground-400 md:text-base">
              开通会员，尊享漫画、钻石漫画等全库专属内容即刻畅读，豪华画质、抢先更新、纯净无广告，尊贵体验一步到位。
            </p>

            <div className="mt-7 flex flex-wrap items-center justify-center gap-3 lg:justify-start">
              {perks.map((p) => (
                <span
                  key={p.label}
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-700 bg-background-900/70 px-4 py-2 text-sm text-foreground-300"
                >
                  <i className={`${p.icon} text-primary-400`}></i>
                  {p.label}
                </span>
              ))}
            </div>
          </div>

          <div className="shrink-0">
            <Link
              to="/vip"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-gradient-to-r from-primary-500 to-accent-500 px-8 py-4 text-base font-bold text-foreground-950 shadow-lg shadow-primary-900/30 transition hover:from-primary-400 hover:to-accent-400 cursor-pointer"
            >
              <i className="ri-vip-diamond-fill text-lg"></i>
              开通会员特权
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VipBanner;